import { ConfigProvider } from 'antd';
import { antdTheme } from './theme/antd-theme';
import { Content } from './content';

export const App = () => (
    <ConfigProvider theme={antdTheme}>
        <Content />
    </ConfigProvider>
);
